import parseInt from 'lodash/parseInt';

import { getDataFromScriptTag } from 'utility/Extract/getDataFromScriptTag';
import { getUrlParams } from 'utility/Provide/Url';

import { RecommendationListRequest } from 'proto/Api/Hotel/RecommendationList';

export const getParamData = (
    hotelId: number,
    isStep35 = false,
    imgSize = 's',
    amount?: number
): RecommendationListRequest => ({
    onlyUseCache: false,
    hotelId: hotelId,
    numberOfRecommendations:
        amount ??
        (getUrlParams('numberofrecommendations')
            ? parseInt(getUrlParams('numberofrecommendations'))
            : 4),
    clientId: getDataFromScriptTag('js-searchd-information')?.clientId,
    hdsCacheId: '',
    imageSize: imgSize,
    hotelIdBlacklist: [],
    isStep35: isStep35,
});
